import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const BathtubIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "BathtubIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M17.8015 17.9189C17.7252 17.9189 17.6494 17.9038 17.5768 17.8744L16.2268 17.3093C15.659 17.48 15.0077 17.5644 14.353 17.5644H9.82708C9.27295 17.5644 8.71977 17.5037 8.18223 17.3842L7.05785 17.8734C6.98627 17.9038 6.9109 17.9189 6.83316 17.9189C6.59757 17.9189 6.38663 17.7786 6.29609 17.5606C6.23589 17.4174 6.23542 17.2591 6.29419 17.115C6.34633 16.9889 6.43877 16.8865 6.55822 16.823C3.93025 15.563 2.24463 12.9019 2.24463 9.98287C2.24463 9.66148 2.50629 9.39982 2.82768 9.39982H4.20945V7.02403C4.20945 6.70264 4.47111 6.44098 4.7925 6.44098H7.29012C7.61151 6.44098 7.87317 6.70264 7.87317 7.02403V8.41576C7.87317 8.73715 7.61151 8.99881 7.29012 8.99881C6.96873 8.99881 6.70707 8.73715 6.70707 8.41576V7.60613H5.37507V9.39983H21.3529C21.6743 9.39983 21.9355 9.66149 21.9355 9.98288C21.9355 12.8014 20.3319 15.4208 17.8328 16.7178L18.0267 16.7993C18.323 16.9225 18.4633 17.2648 18.3395 17.5606C18.248 17.7786 18.0366 17.9189 17.8015 17.9189ZM3.43586 10.565C3.73307 13.8452 6.52032 16.4002 9.82709 16.4002H14.353C17.6598 16.4002 20.4466 13.8452 20.7438 10.565H3.43586Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default BathtubIcon;
